import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    featureFlagOverridesResponseSchema,
    organizationFeatureFlagOverridePathParamsSchema,
    setFeatureFlagOverrideBodySchema,
} from "@common/schemas/featureFlagOverride.schema";
import { OrganizationPathParamsSchema } from "@common/schemas/organization-service.schema";

const c = initContract();

export const organizationFeatureFlagOverrideContract = c.router(
    {
        getOverrides: {
            method: "GET",
            path: "/organizations/:organizationId/overrides",
            pathParams: OrganizationPathParamsSchema,
            responses: {
                200: featureFlagOverridesResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        setOverride: {
            method: "PUT",
            path: "/organizations/:organizationId/overrides/:flag",
            pathParams: organizationFeatureFlagOverridePathParamsSchema,
            body: setFeatureFlagOverrideBodySchema,
            responses: {
                200: featureFlagOverridesResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteOverride: {
            method: "DELETE",
            path: "/organizations/:organizationId/overrides/:flag",
            pathParams: organizationFeatureFlagOverridePathParamsSchema,
            body: c.noBody(),
            responses: {
                200: featureFlagOverridesResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteAllOverrides: {
            method: "DELETE",
            path: "/organizations/:organizationId/overrides",
            pathParams: OrganizationPathParamsSchema,
            body: c.noBody(),
            responses: {
                200: featureFlagOverridesResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/feature-flags",
    },
);
